import {platformBrowserDynamic} from '@angular/platform-browser-dynamic'
import {AppModule} from './app/app.module'
import {AzureLogging} from './app/services/azure-logging.service'

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.error(err)
    AzureLogging.logError(err)
  })
